




import { defineComponent} from '@vue/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ImageType } from '~/types/solepro/PageBuilder';
export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object,
            required: true
        },
    },
    computed: {
        renderHTML(): any {

        /**
         * This was made for SEO purposes, in order to await them to load every alt during the back-office workflow.
         * Derives alt from src, if not present.
         * @param src - The source of the image
         * @returns The alt text
         */
        const deriveAltFromSrc = (src: string): string => {
            const clean = decodeURIComponent(src.split('#')[0].split('?')[0]);
            const file = (clean.split('/').pop() || '').replace(/\.[a-z0-9]+$/i, '');
            return file.replace(/[-_]+/g, ' ').trim();
        };

        const fillAltInHTMLString = (html: string): string => {
            return html.replace(/<img\b([^>]*?)>/gi, (m, attrs) => {
                const srcMatch = attrs.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
                if (!srcMatch) return m;
                const derived = deriveAltFromSrc(srcMatch[1]);

                const altMatch = attrs.match(/\balt\s*=\s*["']([^"']*)["']/i);
                if (!altMatch) {
                    return `<img ${attrs} alt="${derived}">`;
                }
                if (!altMatch[1].trim()) {
                    return m.replace(/\balt\s*=\s*["'][^"']*["']/i, `alt="${derived}"`);
                }
                return m;
            });
        };

        const fillAltInNode = (root: Element | DocumentFragment): Element | DocumentFragment => {
            const imgs = (root as Element).querySelectorAll ? (root as Element).querySelectorAll('img') : [];
            imgs.forEach((img: HTMLImageElement) => {
                const current = (img.getAttribute('alt') || '').trim();
                if (!current) {
                    const src = img.getAttribute('src') || '';
                    if (src) img.setAttribute('alt', deriveAltFromSrc(src));
                }
            });

            return root;
        };

        if (process.server) {
            // @ts-ignore
            const content = this.node.DOMContent;
            if (typeof content === 'string') {
                return fillAltInHTMLString(content);
            } else {
                const html = content?.outerHTML || '';
                return fillAltInHTMLString(html);
            }
        }

        // @ts-ignore
        const content = this.node.DOMContent;
        if (typeof content === 'string') {
            const doc = new DOMParser().parseFromString(content, 'text/html');
            fillAltInNode(doc.body);
            return doc.body.innerHTML;
        } else if (content && content.querySelectorAll) {
            return fillAltInNode(content) as Element;
        }

        return content;
        },
    },
    setup(props, context) {
        //props.node.DOMContent.querySelectorAll('img').forEach(el=>el.classList+=content.cssClasses)
        const content = props.node as ImageType;
        return {
            content
        }
    },
})
